(function () {
  const AUTOPLAY_DELAY = 4000;

  function init() {
    const el = document.querySelector('.clay-worlds__swiper');
    if (!el || typeof Swiper === 'undefined') return;

    let reverseDirection = false;

    const swiper = new Swiper(el, {
      slidesPerView: 1.5,
      spaceBetween: 20,
      breakpoints: {
        640:  { slidesPerView: 2.5 },
        1024: { slidesPerView: 3.5 },
        1536: { slidesPerView: 4.5 },
      },
      autoplay: {
        delay: AUTOPLAY_DELAY,
        disableOnInteraction: false,
      },
      on: {
        activeIndexChange(s) {
          if (s.isEnd)        reverseDirection = true;
          else if (s.isBeginning) reverseDirection = false;
          s.params.autoplay.reverseDirection = reverseDirection;
        },
      },
    });

    // Pause autoplay when section scrolls out of view
    new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) swiper.autoplay.resume();
      else swiper.autoplay.pause();
    }).observe(el);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    // Swiper script is deferred — wait a tick for it to execute
    setTimeout(init, 0);
  }
})();
